
import { StateCreator } from "zustand";
import { SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, AUTH_HEADER } from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchUserFieldWorkChildrenType } from "../../../domain/models/monthly-tour-program/fetch-user-field-work-children";
import { FetchUserFieldWorkChildren } from "../../../domain/useages/monthly-tour-program/fetchUserFieldWorkChildren";
import { RemoteFetchUserFieldWorkChildren } from "../../../data/usecases/monthly-tour-program/remote-fetch-user-field-work-children";

export interface FetchUserFieldWorkChildrenInterface {
  FetchUserFieldWorkChildren: FetchUserFieldWorkChildrenType;
  FetchUserFieldWorkChildrenState: FetchState;
  fetchUserFieldWorkChildren: Function;
}

const initialStates = {
  FetchUserFieldWorkChildren: {} as FetchUserFieldWorkChildrenType,
  FetchUserFieldWorkChildrenState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchUserFieldWorkChildrenSlice: StateCreator<
  FetchUserFieldWorkChildrenInterface
> = (set) => ({
  ...initialStates,
  fetchUserFieldWorkChildren: async (filter: FetchUserFieldWorkChildren.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchUserFieldWorkChildren = new RemoteFetchUserFieldWorkChildren(
      `${BASE_URL}${Endpoints.FETCH_USER_FIELD_WORK_CHILDREN}`,
      axiosHttpClient
    );

    set(() => ({ FetchUserFieldWorkChildrenState: FetchState.LOADING }));
    let result = await remoteFetchUserFieldWorkChildren.fetch(filter);
    return result;
  },
});
